import CookieUtil from '@/util/CookieUtil.ts';

const SESSION_ID = 'sessionId';


const SessionService = {
    getSession(): string | null {
        if (SESSION_ID in sessionStorage) {
            return sessionStorage.getItem(SESSION_ID);
        }
        return localStorage.getItem(SESSION_ID);
    },

    saveSession(sessionId: string, persistent: boolean) {
        if (persistent) {
            localStorage.setItem(SESSION_ID, sessionId);
        }
        sessionStorage.setItem(SESSION_ID, sessionId);
    },

    removeSession() {
        localStorage.removeItem(SESSION_ID);
        sessionStorage.removeItem(SESSION_ID);
    }
};

export default SessionService;
